module.exports = new __parcel__URL__("issues-preview.c08edc67.svg").toString();